// extracted by mini-css-extract-plugin
export default {"container":"Team_container__farNv","heading":"Team_heading__XkrYA","content":"Team_content__4WnCN"};